/**
 * question: Do you already have your product sold in the market?
 * == baseline
 * product_sold_t0
 * 
 * @param props 
 * @returns 
 */
export const entrepreneursDidNotProductsTotalCalculation = (props: any): string => {
    const total = props.uoas.length;
    const saidNo = props.baselineSubmissions.filter((submission: any) => submission.product_sold_t0 === 'No').length;

    return (saidNo / total * 100).toFixed(2);
}